module.exports = __webpack_public_path__ + "media/images/icons/success_smile-0e992e780eed7fda4fad137fbad9aa57.svg";